import { Reveal, SectionHeading } from "./decor";
import { useLang } from "../i18n";

const StagePlan = () => (
  <svg viewBox="0 0 800 420" className="w-full h-auto" role="img" aria-label="Stage plan diagram">
    <rect x="20" y="20" width="760" height="380" fill="#121216" stroke="#3f3f46" strokeWidth="2" />
    <line x1="20" y1="70" x2="780" y2="70" stroke="#27272A" strokeWidth="1" strokeDasharray="6 6" />
    <text x="400" y="52" textAnchor="middle" fill="#52525b" fontSize="13" fontFamily="JetBrains Mono, monospace" letterSpacing="4">UPSTAGE / BACKLINE</text>

    <rect x="300" y="90" width="200" height="110" fill="#18181F" stroke="#DC2626" strokeWidth="2" />
    <text x="400" y="140" textAnchor="middle" fill="#F9FAFB" fontSize="16" fontFamily="JetBrains Mono, monospace" letterSpacing="3">DRUM RISER</text>
    <text x="400" y="162" textAnchor="middle" fill="#6B7280" fontSize="11" fontFamily="JetBrains Mono, monospace">3m x 2m — MIX 4 FILL</text>

    <rect x="80" y="100" width="120" height="60" fill="#18181F" stroke="#3f3f46" strokeWidth="1.5" />
    <text x="140" y="135" textAnchor="middle" fill="#9CA3AF" fontSize="12" fontFamily="JetBrains Mono, monospace">GTR AMP 4x12</text>
    <rect x="600" y="100" width="120" height="60" fill="#18181F" stroke="#3f3f46" strokeWidth="1.5" />
    <text x="660" y="135" textAnchor="middle" fill="#9CA3AF" fontSize="12" fontFamily="JetBrains Mono, monospace">AMPEG 8x10</text>

    <circle cx="180" cy="260" r="10" fill="#DC2626" />
    <text x="180" y="240" textAnchor="middle" fill="#F9FAFB" fontSize="13" fontFamily="JetBrains Mono, monospace" letterSpacing="2">GUITAR L</text>
    <circle cx="620" cy="260" r="10" fill="#DC2626" />
    <text x="620" y="240" textAnchor="middle" fill="#F9FAFB" fontSize="13" fontFamily="JetBrains Mono, monospace" letterSpacing="2">BASS R</text>
    <circle cx="400" cy="300" r="10" fill="#DC2626" />
    <text x="400" y="280" textAnchor="middle" fill="#F9FAFB" fontSize="13" fontFamily="JetBrains Mono, monospace" letterSpacing="2">LEAD VOX C</text>

    <path d="M150 330 l60 0 l-10 22 l-40 0 z" fill="#18181F" stroke="#3f3f46" />
    <text x="180" y="376" textAnchor="middle" fill="#6B7280" fontSize="11" fontFamily="JetBrains Mono, monospace">MIX 2</text>
    <path d="M370 340 l60 0 l-10 22 l-40 0 z" fill="#18181F" stroke="#DC2626" strokeWidth="1.5" />
    <text x="400" y="386" textAnchor="middle" fill="#6B7280" fontSize="11" fontFamily="JetBrains Mono, monospace">MIX 1</text>
    <path d="M590 330 l60 0 l-10 22 l-40 0 z" fill="#18181F" stroke="#3f3f46" />
    <text x="620" y="376" textAnchor="middle" fill="#6B7280" fontSize="11" fontFamily="JetBrains Mono, monospace">MIX 3</text>

    <text x="400" y="410" textAnchor="middle" fill="#52525b" fontSize="13" fontFamily="JetBrains Mono, monospace" letterSpacing="4">FRONT OF STAGE — AUDIENCE</text>
  </svg>
);

export const TechRider = () => {
  const { t } = useLang();
  return (
    <section id="rider" data-testid="tech-rider-section" className="relative py-24 sm:py-32 bg-[#0D0D10]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHeading kicker={t.rider.kicker} title={t.rider.title} testId="rider-heading" />

        <Reveal className="bg-[#121216] border border-zinc-800 p-6 sm:p-10 max-w-4xl mx-auto">
          <h3 className="font-display text-3xl tracking-wide uppercase text-white mb-6">{t.rider.stagePlan}</h3>
          <StagePlan />
        </Reveal>
      </div>
    </section>
  );
};
